<template>
  <div>
    <div v-for="item in modalDataSelf" :key="item.menuCode">
      <div class="list-title">{{ item.menuName }}</div>
      <div class="flexStart list-main">
        <div class="list-item">
          <a-checkbox
            v-for="sub in item.subnav"
            :key="sub.menuCode"
            style="margin:0 10px 5px 0;"
            v-model="sub.checked"
            :value="sub.menuCode"
            :disabled="sub.modified == 0"
            @change="onChange($event, sub)"
          >
            {{ sub.label }}
          </a-checkbox>
        </div>
      </div>
      <div v-if="item.menuCode == 'MENU0400'">
        <!-- 待办任务菜单下的开立复核多级选项 -->
        <issueReviewModal
         class="issue-review-box"
          ref="issueReviewModal"
          v-show="showIssueReview"
          roleCode="ROLE0002"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { updateApi } from "@/api/menu.js";
import issueReviewModal from "./issue-review-modal.vue";
export default {
  props: ["modalData"],
  name: "characterEditModal",
  components: {
    issueReviewModal
  },
  data() {
    return {
      modalDataAll: this.utils.deepClone(this.modalData),
      modalDataSelf: [],
      loading: true,
      issueReviewData: {}, //开立复核多级弹窗数据
      issueReview: "MENU0402", //开立复核menucode
      showIssueReview: false
    };
  },
  computed: {},
  methods: {
    check() {
      // 校验开立复核弹窗数据是否正确
      if (this.showIssueReview) {
        this.issueReviewData = this.$refs.issueReviewModal[0].saveBebore();
        return this.issueReviewData;
      }
      return true;
    },
    async modalOk() {
      // 保存开立复核数据
      if(this.modalData.roleCode == "ROLE0002"){
        await this.$refs.issueReviewModal[0] &&
        this.$refs.issueReviewModal[0].save(this.issueReviewData.params);
      }


      return new Promise((resolve, reject) => {
        const params = this.modalDataAll;
        params["paramsStr"] = JSON.stringify(params);
        delete params.nav;
        updateApi(params)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    onChange(e, item) {
      //判断是否为开立复核权限，如是进行开立复核多级逻辑操作
      if (item.menuCode == this.issueReview) {
        if (e.target.checked) {
          this.showIssueReview = true;
        } else {
          this.showIssueReview = false;
          this.issueReviewData.params = [];
        }
      }

      item.checked = e.target.checked;
      item.isCheck = item.checked ? "1" : "0";
    }
  },
  created() {
    const list = this.modalDataAll.nav;
    for (let i = 0; i < list.length; i++) {
      if (list[i].subnav && list[i].subnav.length == 0) {
        list[i].subnav.push({
          isCheck: "1",
          menuCode: list[i].menuCode,
          menuName: list[i].menuName,
          modified: "0"
        });
      }

      for (let j = 0; j < list[i].subnav.length; j++) {
        this.$set(
          list[i].subnav[j],
          "disabled",
          list[i].subnav[j].modified == 0
        );
        this.$set(list[i].subnav[j], "checked", list[i].subnav[j].isCheck == 1);
        this.$set(list[i].subnav[j], "value", list[i].subnav[j].menuCode);
        this.$set(list[i].subnav[j], "label", list[i].subnav[j].menuName);

        // 开立复核多级显示
        if (
          list[i].subnav[j].menuCode == this.issueReview &&
          list[i].subnav[j].isCheck == 1
        ) {
          this.showIssueReview = true;
          this.$nextTick(() => {
            this.$refs.issueReviewModal[0] &&
              this.$refs.issueReviewModal[0].open({
                readonly: list[i].subnav[j].disabled
              });
          });
        }
      }
    }
    this.modalDataSelf = list;
  },
  mounted() {},
  activated() {},
  watch: {}
};
</script>
<style scoped lang="less">
.list-title {
  margin-bottom: 15px;
}
.list-main {
  flex: 1 0 0;
  padding-left: 15px;
}
.list-item {
  margin-bottom: 15px;
}
.issue-review-box {
  background: rgb(245 249 251);
  position: relative;
  margin-left: 14px;
  padding: 16px 16px 6px 16px;
  margin-bottom: 16px;
  &::before {
    content: "开立复核";
    position: absolute;
    left: 12px;
    top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/character/character-edit-modal.vue